export const contactTitles = [
    "", "Mr.", "Ms.", "Mrs.", "Professor", "Associate Professor", "Assistant Professor", "Lecturer", "Dr.", "Special Teaching Staff", "Special Laboratory Teaching Staff", "Special Technical Laboratory Teaching Staff", "Scientific Teaching Staff", "Laboratory Teaching Staff", "Temporary Teaching Staff", "External Teaching Staff", "Temporary Staff", "Administrative Staff"
]

export default {
    contactTitles
}